import React from "react";
import { Box, Typography } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { COLOR_MAP } from "../../../../../constants/ColorNames";

const LeftSection = () => {
  return (
    <Box
      sx={{
        pl: 2,
        pr: 1,
        display: "flex",
        alignItems: "center",
        position: "relative",
        width: "100%",
        boxSizing: "border-box",
      }}
    >
      <Box
        sx={{
          border: "2px solid",
          borderColor: COLOR_MAP.DARK_PURPLE,
          display: "flex",
          borderRadius: 2,
          width: "100%",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            width: 70,
            backgroundColor: COLOR_MAP.GREY_9,
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
        >
          <WhatsAppIcon sx={{ fontSize: 28 }} />
        </Box>

        <Box sx={{ backgroundColor: COLOR_MAP.WHITE, p: 1, flexGrow: 1 }}>
          <Typography
            variant="h5"
            sx={{ fontWeight: "fontWeightBold", mb: 0.75 }}
          >
            New job opportunity
          </Typography>
          <Typography variant="h5" sx={{ color: COLOR_MAP.GREY_3 }}>
            Campaign start
          </Typography>
        </Box>
      </Box>
      <ArrowRightIcon
        sx={{
          position: "absolute",
          fontSize: 48,
          color: COLOR_MAP.DARK_PURPLE,
          right: -20,
        }}
      />
    </Box>
  );
};

export default React.memo(LeftSection);
